import * as types from '../constants'
import _ from 'lodash'


const initState = {
    listCategory:[],
    
    listOffer: {},


    detaiEndow:{},


    exchangeShopping:{}
}


export default function (state = initState,action){
    switch (action.type) {
        case types.GET_LIST_OFFER_CATEGORY:
            state.listCategory = [],
            action.payload.forEach((item, i)=>{
                state.listCategory.push(item)
                
            })
            return _.cloneDeep(state)
        break;
        case types.GET_LIST_OFFER:
            state.listOffer[action.payload.offerId] = action.payload.data 
            return _.cloneDeep(state)
        break;

        case types.GET_DETAIL_ENDOW:
            state.detaiEndow = action.payload 
            return _.cloneDeep(state)
        break;
        case types.GET_EXCHANGE_SHOPPING:
            state.exchangeShopping = action.payload 
            return _.cloneDeep(state)
        break;
        default:
            return state;
    }
}